// extracted by mini-css-extract-plugin
module.exports = {"titleForm":"titleForm_titleForm__1J-vV","iconMobile":"titleForm_iconMobile__it77r"};